import React from 'react';
import { BackButton, Loading, VehiclePanel } from '../../components';
import { useSelector } from 'react-redux';
import { TripState } from '../../types/trip.store.type';
import { useTripStoreUpdater } from '../../hooks';
import { ImageVehicleInfo } from '../../assets/images';

import '../../styles/_vehicle-registration.scss';
import { TranslationUtils } from '../../utils';

export const VehicleRegistration: React.FC = () => {
    useTripStoreUpdater(true);

    const { required_actions: requiredActions, reservation, isLoading } = useSelector((store: { trip: TripState }) => store.trip);

    if (isLoading) {
        return <Loading />;
    }

    if (!requiredActions || !requiredActions.vehicle_registration || !reservation) {
        return null;
    }

    return (
        <div>
            <BackButton path="/reservation" />
            <h1 className="page-title">{TranslationUtils.get('vehicle_registration')}</h1>
            <div className="registration-body">
                <div className="registration-text">
                    <div dangerouslySetInnerHTML={{ __html: requiredActions.vehicle_registration.vehicle_info_text }} />
                </div>
                <div className="registration-image">
                    <ImageVehicleInfo className="d-none d-md-block" />
                </div>
            </div>
            <div>
                <VehiclePanel vehicleRegistration={requiredActions.vehicle_registration} reservation={reservation} />
            </div>
        </div>
    );
};
